<template>
  <div class='mainBody'>
    <listContent></listContent>
    <monthCalendar></monthCalendar>
   <!-- <addSchedule :dialogVisible="true"></addSchedule>
    <addProject :dialogVisible="false"></addProject>-->
  </div>
</template>

<script>
import listContent from './listContent.vue'
import monthCalendar from './monthCalendar.vue'
// import addSchedule from '../../others/addSchedule.vue'
// import addProject from '../../others/addProject.vue'
export default {
  name: 'mainBody',
  components: {
    listContent,
    monthCalendar
    // addSchedule,
    // addProject
  },
  data: function () {
    return {
    }
  }
}
</script>

<style lang="stylus" scoped>
  .mainBody
    position absolute
    top 4rem
    bottom 0rem
    left 0rem
    right 0rem
</style>



// WEBPACK FOOTER //
// src/pagesPc/main/component/mainBody.vue